<section id="select-concat-operation">
  <div id="concat-fields">
    <div class="title">1.</div>
    <div>
      <app-toggle-group-btn
        [primaryEntity]="primaryEntity"
        [meta]="meta"
        [data]="concatField.parameters[0]"
        [metaType]="'string'"
        (parameterForm)="updateParameter($event,0)"
        (secondaryEntity)="getNewMeta($event)">>
      </app-toggle-group-btn>
    </div>
    <div class="title">2.</div>
    <div>
      <app-toggle-group-btn
        [primaryEntity]="primaryEntity"
        [meta]="meta"
        [data]="concatField.parameters[1]"
        [metaType]="'string'"
        (parameterForm)="updateParameter($event,1)"
        (secondaryEntity)="getNewMeta($event)">
      </app-toggle-group-btn>
    </div>
    <div>
      <span class="material-icons notranslate tooltip-icon danger"
            matTooltip="{{truncWarningToolTip}}"
            matTooltipClass="mat-tooltip">error_outline</span>
    </div>
  </div>
  <div id="delimiter_message">
    <div id="operators">
      <h4 class="to">Delimiter: </h4>
      <label class="concat-operators">
        <input type="text"
               (change)="changeDelimiter()"
               [formControl]="delimiterValue"
               class="concatenate-input">
      </label>
    </div>
    <div id="concatMessageResult">
      <label>
        Result: <label [innerHTML]="messageResult"></label>
      </label>
    </div>
  </div>
</section>


